module.exports = __webpack_public_path__ + "img/恐惧.45fb242a.png";